// Centralised auth token storage.
// Uses sessionStorage so tokens are cleared when the browser session ends
// (tab/window close), reducing exposure on shared computers.
//
// NOTE: sessionStorage is still accessible to JavaScript running on the page.
// The proper long-term fix is httpOnly cookies set by the backend on login so
// tokens never touch client-side JS at all. That requires backend changes to
// POST /auth/login and the auth middleware to read cookies.
const storage = sessionStorage;

const authStorage = {
  getToken: () => storage.getItem('token'),
  setToken: (t) => storage.setItem('token', t),
  removeToken: () => storage.removeItem('token'),

  getRefreshToken: () => storage.getItem('refreshToken'),
  setRefreshToken: (t) => storage.setItem('refreshToken', t),
  removeRefreshToken: () => storage.removeItem('refreshToken'),

  getUser: () => {
    try {
      return JSON.parse(storage.getItem('user') || 'null');
    } catch {
      return null;
    }
  },
  setUser: (u) => storage.setItem('user', JSON.stringify(u)),
  removeUser: () => storage.removeItem('user'),

  clear: () => {
    storage.removeItem('user');
    storage.removeItem('token');
    storage.removeItem('refreshToken');
  },
};

export default authStorage;
